import { ParsableDate } from "@material-ui/pickers/constants/prop-types";
import moment from "moment";

export function addEventInputsChange(value: string, listener) {
	if (value) {
		var values = value.split("&");

		for (var i = 0; i < values.length; i++) {
			var date = values[i];

			if (date.startsWith("[#")) {
				var elementId = date.substring(2, date.length - 1);
				var element = document.getElementById(elementId) as HTMLInputElement;
				element?.addEventListener("change", listener)
			}
		}
	}
}

export function removeEventInputsChange(value: string, listener) {
	if (value) {
		var values = value.split("&");

		for (var i = 0; i < values.length; i++) {
			var date = values[i];

			if (date.startsWith("[#")) {
				var elementId = date.substring(2, date.length - 1);
				var element = document.getElementById(elementId) as HTMLInputElement;
				element?.removeEventListener("change", listener)
			}
		}
	}
}

export function minCalculate(value: string): ParsableDate{
	var currentDate: moment.Moment = undefined; 
	if (value) {

		var values = value.split("&");
		
		for (var i = 0; i < values.length; i++) {
			var date = tryParse(values[i]);
			if (!date)
				continue;

			if (!currentDate) {
				currentDate = date;
				continue;
			}

			if (currentDate.isSameOrBefore(date)) {
				currentDate = date;
				continue;
			}
		}
	}

	return currentDate;
}

export function maxCalculate(value: string): ParsableDate {
	var currentDate: moment.Moment = undefined;
	if (value) {

		var values = value.split("&");

		for (var i = 0; i < values.length; i++) {
			var date = tryParse(values[i]);
			if (!date)
				continue;

			if (!currentDate) {
				currentDate = date;
				continue;
			}

			if (currentDate.isSameOrAfter(date)) {
				currentDate = date;
				continue;
			}
		}
	}

	return currentDate;
}

function tryParse(value: string): moment.Moment {
	if (!value)
		return null;

	if (value[0] != '[') {
		var date = moment(value);
		if (!date.isValid()) {
			return null;
		}
		return date;
	}

	if (value.toLowerCase() == '[now]') {
		return moment();
	}

	if (value.toLowerCase() == '[today]') {
		return moment({ hour: 0 });
	}

	if (value.startsWith("[#")) {
		var elementId = value.substring(2, value.length - 1);
		var element = document.getElementById(elementId) as HTMLInputElement;
		if (element?.value) {
			var date = moment(element.value);
			if (date.isValid()) {
				return date;
			}
		}
		return null;
	}
}